if (!customElements.get('form-disclosure-select')) {
  class FormDisclosureSelect extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.select = this.querySelector('select');
      this.button = this.querySelector('.disclosure__button');
      this.panel = this.querySelector('.disclosure__list-wrapper');
      this.valueEl = this.querySelector('.disclosure__value');
      this.labelEl = this.querySelector('label');
      this.options = Array.from(this.querySelectorAll('[role="option"]'));

      if (!this.select || !this.button || !this.panel) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggle();
      });
      this.addEventListener('keydown', this.onKeyDown.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.options.forEach((option) => {
        option.addEventListener('click', () => this.selectOption(option));
      });
      document.addEventListener('click', this.onDocumentClick.bind(this));
      this.select.addEventListener('change', () => this.syncFromSelect());
      this.syncFromSelect();
    }

    isOpen() {
      return this.button.getAttribute('aria-expanded') === 'true';
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.hide();
    }

    onFocusOut(event) {
      if (this.contains(event.relatedTarget)) return;
      this.hide();
    }

    toggle() {
      if (this.isOpen()) this.hide();
      else this.show();
    }

    show() {
      if (typeof DisclosurePanel !== 'undefined') {
        DisclosurePanel.closeSiblings(this.panel, this.closest('.form__container') || this);
        DisclosurePanel.show(this.panel, this.button);
      } else {
        this.panel.removeAttribute('hidden');
        this.button.setAttribute('aria-expanded', 'true');
      }
      this.classList.add('is-open');
      this.classList.toggle('is-open-up', this.panel.dataset.disclosureDirection === 'up');
      const selected = this.options.find((option) => option.getAttribute('aria-selected') === 'true') || this.options[0];
      if (selected) selected.focus({ preventScroll: true });
    }

    hide() {
      if (!this.isOpen()) return;
      if (typeof DisclosurePanel !== 'undefined') {
        DisclosurePanel.hide(this.panel, this.button);
      } else {
        this.panel.setAttribute('hidden', '');
        this.button.setAttribute('aria-expanded', 'false');
      }
      this.classList.remove('is-open', 'is-open-up');
    }

    visibleOptions() {
      return this.options.filter((option) => !option.hidden);
    }

    moveFocus(key) {
      const options = this.visibleOptions();
      if (!options.length) return;
      let index = options.indexOf(document.activeElement);
      if (key === 'Home') index = 0;
      else if (key === 'End') index = options.length - 1;
      else if (key === 'ArrowUp') index = index > 0 ? index - 1 : options.length - 1;
      else index = index < options.length - 1 ? index + 1 : 0;
      options[index].focus();
    }

    selectOption(option) {
      if (!option) return;
      this.select.value = option.getAttribute('data-value') || '';
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncFromSelect();
      this.hide();
      this.button.focus();
    }

    syncFromSelect() {
      const value = this.select.value;
      this.options.forEach((option) => {
        const selected = option.getAttribute('data-value') === value && value !== '';
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      const selectedOption = this.options.find((option) => option.getAttribute('aria-selected') === 'true');
      const placeholder = this.valueEl.getAttribute('data-label') || '';
      this.valueEl.textContent = selectedOption ? selectedOption.textContent.trim() : placeholder;
      this.valueEl.classList.toggle('disclosure__value--placeholder', !selectedOption);
      if (this.labelEl) {
        this.button.setAttribute(
          'aria-labelledby',
          selectedOption ? `${this.labelEl.id} ${this.valueEl.id}` : this.labelEl.id
        );
      }
    }

    setInvalid(isInvalid, errorId) {
      this.button.setAttribute('aria-invalid', isInvalid ? 'true' : 'false');
      if (isInvalid && errorId) this.button.setAttribute('aria-describedby', errorId);
      else this.button.removeAttribute('aria-describedby');
      this.button.classList.toggle('input-error', isInvalid);
    }

    onKeyDown(event) {
      const key = event.key;
      const isTrigger = event.target === this.button;
      const isOption = event.target.getAttribute && event.target.getAttribute('role') === 'option';

      if (key === 'Escape') {
        if (!this.isOpen()) return;
        event.preventDefault();
        event.stopPropagation();
        this.hide();
        this.button.focus();
        return;
      }

        if (key === 'Enter' || key === ' ') {
          if (isTrigger) {
            event.preventDefault();
            if (!this.isOpen()) this.show();
            return;
          }
          if (!this.isOpen()) return;
        event.preventDefault();
        const focused = isOption ? event.target : this.visibleOptions()[0];
        this.selectOption(focused);
        return;
      }

      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(key)) return;

      if (isTrigger) {
        event.preventDefault();
        if (!this.isOpen()) this.show();
        else this.moveFocus(key);
        return;
      }

      if (!this.isOpen()) return;
      event.preventDefault();
      this.moveFocus(key);
    }
  }

  customElements.define('form-disclosure-select', FormDisclosureSelect);
}
